// extracted by mini-css-extract-plugin
module.exports = {"main":"leadership-hero-module--main--3mL8e","heroImage":"leadership-hero-module--hero-image--1nK37","dna":"leadership-hero-module--dna--3hCFG"};